var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiamondBadge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 147,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "24.73%",
    x2: "100%",
    y2: "74.91%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA68C8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B1FA2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.85.65l60.38 34.17a5 5 0 0 1 2.54 4.35v68.17a5 5 0 0 1-2.54 4.35l-60.38 34.17a5 5 0 0 1-4.93 0L2.54 111.7A5 5 0 0 1 0 107.34V39.17a5 5 0 0 1 2.54-4.35L62.92.65a5 5 0 0 1 4.93 0zm-.25 12a5 5 0 0 0-4.92 0L12.9 40.82a5 5 0 0 0-2.54 4.35v56.17a5 5 0 0 0 2.54 4.35l49.78 28.17a5 5 0 0 0 4.92 0l49.79-28.17a5 5 0 0 0 2.53-4.35V45.17a5 5 0 0 0-2.53-4.35L67.6 12.65z",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6 12.65l49.79 28.17a5 5 0 0 1 2.53 4.35v56.17a5 5 0 0 1-2.53 4.35L67.6 133.86a5 5 0 0 1-4.92 0L12.9 105.7a5 5 0 0 1-2.54-4.35V45.17a5 5 0 0 1 2.54-4.35l49.78-28.17a5 5 0 0 1 4.92 0z",
    id: "c"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-.4%",
    y: "-6.7%",
    width: "100.8%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    in: "SourceAlpha",
    result: "shadowSpreadInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowSpreadInner1",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "f",
    cx: 65,
    cy: 79.5,
    rx: 6,
    ry: 7.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-612.5%",
    y: "-490%",
    width: "1325%",
    height: "1080%",
    filterUnits: "objectBoundingBox",
    id: "e"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 13,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.592151523 0 0 0 0 0.726388156 0 0 0 1 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-25.6%",
    y: "-31.2%",
    width: "151.2%",
    height: "161.1%",
    filterUnits: "objectBoundingBox",
    id: "g"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.38 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M42.2-25.4l6.77 15.45v34L42.2 39.47l-7.15-15.92v-33z"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-21.5%",
    y: "-4.6%",
    width: "143.1%",
    height: "109.2%",
    filterUnits: "objectBoundingBox",
    id: "i"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    in: "SourceAlpha",
    result: "shadowSpreadInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowSpreadInner1",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M0 16.5L9.56.24 10 20.65z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "66.71%",
    y1: "-15.36%",
    x2: "-12.1%",
    y2: "124.48%",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1BEE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B1FA2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M9.55.23L25 7 10 20.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M10.01 20.64L25 7l-2 18.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.99%",
    y1: "-22.08%",
    x2: "55.99%",
    y2: "70.7%",
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3E5F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA68C8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M25 7h17.26L42 26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E24AA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA68C8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E24AA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3E5F5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M23 33h19v38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M0 16.5L9.56.23l.73 20.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M9.57.23L25 7 10.3 20.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "M10.05 21L25 7l-2 19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "M25 7h17.26L42 26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "x"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA68C8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE93D8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M42 23.5l41.97 48-19-38.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB47BC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "M42 33h19v38.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "B",
    cx: 25.25,
    cy: 14.25,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4500%",
    y: "-4500%",
    width: "9257.3%",
    height: "9112.3%",
    filterUnits: "objectBoundingBox",
    id: "A"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "D",
    cx: 4.5,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-225%",
    y: "-225%",
    width: "550%",
    height: "542.3%",
    filterUnits: "objectBoundingBox",
    id: "C"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.25,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "52.87%",
    fx: "50%",
    fy: "52.87%",
    r: "26.48%",
    gradientTransform: "matrix(-.89376 -.10621 .09547 -.99434 .9 1.1)",
    id: "F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F06292",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M7.54 2l-.28 5.04-5.26.3 5.26.4v4.24l.5-4.25 5.34-.38-5.34-.31z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "H",
    cx: 7.5,
    cy: 7.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-300%",
    y: "-300%",
    width: "700%",
    height: "690.4%",
    filterUnits: "objectBoundingBox",
    id: "G"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.961659253 0 0 0 0 0.48327148 0 0 0 0 0.638882816 0 0 0 1 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "J",
    cx: 7.5,
    cy: 7.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-300%",
    y: "-300%",
    width: "700%",
    height: "690.4%",
    filterUnits: "objectBoundingBox",
    id: "I"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "L",
    cx: 7.5,
    cy: 7.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-300%",
    y: "-300%",
    width: "700%",
    height: "690.4%",
    filterUnits: "objectBoundingBox",
    id: "K"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#8E24AA",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#d)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    filter: "url(#e)",
    xlinkHref: "#f",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)",
    transform: "translate(23 42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 42.01 7.04)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#E8CCEC",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#i)",
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#9C27B0",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "#FFF",
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.89,
    fill: "url(#l)",
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#9C27B0",
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "#FFF",
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E1BEE7",
    d: "M23 33h19L25 14z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#BB62C8",
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#o)",
    xlinkHref: "#n"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M0 23.5l42 48L23 33z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#CE93D8",
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.6,
    fill: "url(#r)",
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 84 7)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#9C27B0",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "#FFF",
    xlinkHref: "#s"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 84 7)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.89,
    fill: "url(#l)",
    xlinkHref: "#t"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 84 7)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#9C27B0",
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "#FFF",
    xlinkHref: "#u"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E1BEE7",
    d: "M61 33H42l17-19z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 84 7)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#BB62C8",
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#o)",
    xlinkHref: "#v"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 125.97 0)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.8,
    fill: "url(#x)",
    xlinkHref: "#w"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 103 0)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#CE93D8",
    xlinkHref: "#y"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.6,
    fill: "url(#z)",
    xlinkHref: "#y"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#A)",
    xlinkHref: "#B"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    opacity: 0.46,
    d: "M47.39 72.3L46.06 75l-2.98-1.05 2.82 1.44-1 2.34 1.27-2.22 3.04 1.04-2.88-1.42z"
  }), /*#__PURE__*/React.createElement("use", {
    filter: "url(#C)",
    xlinkHref: "#D",
    fill: "#000",
    transform: "translate(42 71)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46,
    transform: "rotate(-12 291.33 -40.07)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#E"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#F)",
    xlinkHref: "#E"
  })), /*#__PURE__*/React.createElement("use", {
    filter: "url(#G)",
    xlinkHref: "#H",
    fill: "#000",
    transform: "rotate(-35 107.48 10.63)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    opacity: 0.46,
    d: "M98.49 64.4l-2.22 4.52-4.97-1.77 4.7 2.41-1.67 3.9 2.12-3.7 5.07 1.73-4.8-2.38z"
  }), /*#__PURE__*/React.createElement("use", {
    filter: "url(#I)",
    xlinkHref: "#J",
    fill: "#000",
    transform: "translate(89 62)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    opacity: 0.46,
    d: "M66.49 107.4l-2.22 4.52-4.97-1.77 4.7 2.41-1.67 3.9 2.12-3.7 5.07 1.73-4.8-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    opacity: 0.46,
    d: "M62.61 107.4l2.23 4.52 4.96-1.77-4.7 2.41 1.67 3.9-2.12-3.7-5.07 1.73 4.8-2.38z"
  }), /*#__PURE__*/React.createElement("use", {
    filter: "url(#K)",
    xlinkHref: "#L",
    fill: "#000",
    transform: "translate(57 105)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiamondBadge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/diamond-badge.2a8a0cea40169badb960c9b368bcfe67.svg";